/// <reference path="jquery.min.js" />
/// <reference path="jRespond.js" />
/// <reference path="jquery.inview.js" />

// Cookie functions
function getCookie(cname) {
    'use strict';

    var name = cname + '=',
        ca = document.cookie.split(';'),
        i,
        c;

    for (i = 0; i < ca.length; i = i + 1) {
        c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

function setCookie(cname, cvalue, exdays) {
    'use strict';

    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    var ovalue = getCookie(cname);
    if (ovalue !== null && ovalue !== '') {
        cvalue = ovalue + ',' + cvalue;
    }
    document.cookie = cname + '=' + cvalue + '; ' + expires;
}

function checkCookie(cname, id) {
    'use strict';

    var cvalue = getCookie(cname);
    if (cvalue !== null && cvalue.indexOf(id) >= 0) {
        return cvalue;
    } else {
        return null;
    }
}

function chatbot_answer(step, value){
    if(step == 2 && value == 'Neustart')
    {
        location.href = '/allgemein/chatbot';
        return;
    }
    
    $('.choice').hide();
    var msg = '<div class="user-inbox inbox"><div class="msg-header"><p>'+ value +'</p></div></div>';
    $(".form").append(msg);
    
    $.ajax({
        url: '/allgemein/chatbot',
        type: 'POST',
        data: 'step='+step+'&text='+value,
        success: function(result){
            $(".form").append('<img id="loading" src="/assets/img/loading.gif" />');
            $(".form").scrollTop($(".form")[0].scrollHeight);
            setTimeout(function(){
                $('#loading').remove(); 
                $(".form").append(result);
                $(".form").scrollTop($(".form")[0].scrollHeight); 
            }, 1000);
            
        }
    });
}

function seourl(name) {
    name = name.toLowerCase(); 
    name = name.replace(/ä/g, 'ae');
    name = name.replace(/ö/g, 'oe');
    name = name.replace(/ü/g, 'ue');
    name = name.replace(/ß/g, 'ss');
    name = name.replace(/&/g, 'und');
    name = name.replace(/^\s+|\s+$/g, ''); // remove leading and trailing whitespaces
    name = name.replace(/\s+/g, '-'); // convert (continuous) whitespaces to one -
    name = name.replace(/[^a-z0-9-]/g, ''); // remove everything that is not [a-z] or -
    name = name.replaceAll('---', '-');
    name = name.replaceAll('--', '-');
    return name;
}


var lazyLoadInstance = new LazyLoad({
    // Your custom settings go here
});

// Touch Device erkennen
var deviceSupportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;


$(document).ready(function() {
    'use strict';

    /* Declare global Variables */
    var jRes, isMobile, userAgent, play_store_url, ios_store_url;

    /* Android Play Store Url */
    play_store_url = $('body').data('play-store-url');
    /* Apple iOS Store Url */
    ios_store_url = $('body').data('ios-store-url');

    /* Remove no-js class at html tag */
    $('html').removeClass('no-js');

    /* Initiate jRespond and assign breakpoints */
    jRes = jRespond([{
        label: 'smartphone',
        enter: 0,
        exit: 767
    }, {
        label: 'tablet',
        enter: 768,
        exit: 991
    }, {
        label: 'desktop',
        enter: 992,
        exit: 10000
    }]);

    isMobile = {
        android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        blackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        opera: function() {
            return navigator.userAgent.match(/Opera\ Mini/i);
        },
        windows: function() {
            return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
        },
        any: function() {
            return (isMobile.android() || isMobile.blackBerry() || isMobile.iOS() || isMobile.opera() || isMobile.windows());
        }
    };

    /* Display or hide elements on mobile devices */
    if (isMobile.android()) {
        $('.hidden-mobileos').hide();
        $('.visible-android').show();
        userAgent = 'android';
    } else if (isMobile.blackBerry()) {
        $('.hidden-mobileos').hide();
        $('.visible-blackberry').show();
        userAgent = 'blackberry';
    } else if (isMobile.windows()) {
        $('.hidden-mobileos').hide();
        $('.visible-windows').show();
        userAgent = 'windows';
    } else if (isMobile.iOS()) {
        $('.hidden-mobileos').hide();
        $('.visible-ios').show();
        userAgent = 'ios';
    }
    
    if (isMobile.any()) {  // is a mobile
        $('.visible-mobileos').show();
    }

    var ToastSwal = Swal.mixin({
        toast: true,
        position: 'bottom',  // top | top-start | top-end | center | center-start | center-end | bottom | bottom-start | bottom-end
        showConfirmButton: false,
        //background: '#666',
        timer: 2000,
        timerProgressBar: true
    });

    /* SweetAlert with History Hash Value */
    var CustomHashSwal = Swal.mixin({
        onOpen: (function (result) {
            window.location.hash = "swal";
        }),
        onClose: (function (result) {
            if(window.location.hash == "#swal") {
                window.history.back();
            }
        })
    });

    // Scrollto function
    function scrollToPosition(element, animation_duration) {
        'use strict';
        var breakpoint = jRes.getBreakpoint();
        var offset = 0;
        if (typeof animation_duration === 'undefined') { animation_duration = 1000; }
        
        if (breakpoint === 'smartphone') {
            offset = 0;
        }
        $('html, body').stop().animate({
            scrollTop: $(element).offset().top - offset
        }, animation_duration);
        return false;
    }

    // initiate tooltips
    $('body').tooltip({
        selector: '[data-toggle=tooltip]',
        delay: {'show': 250, "hide": 50}
    });

    /* loading button on click */
    $('body').on('click', '.btn.btn-loading', function(e) {
        var $btn = $(this);
        if ($(".form-general").length) {
            if($btn.closest('form')[0].checkValidity()){  // show loading only, if closest formular is valid!
                $btn.button('loading');
            }
        }
    });

    $('body').on('shown.bs.modal', '.modal', function (e) {
        var $modal = $(this);
        $modal.animate({ scrollTop: 0 }, 'slow');
    });

    $('body').on('show.bs.modal', '.modal', function (e) {
        var $modal = $(this);
        var $trigger = $(e.relatedTarget);
        var hash_val = $trigger.attr('data-hash') !== undefined ? $trigger.attr('data-hash') : 'modal';

        if($modal.is('#modal-share-product')){
            hash_val = 'share';
        }
        window.location.hash = hash_val;

        if($('#pageup').hasClass('active')){
            $('#pageup').removeClass('active');
        }

        // fix um mehrere Modals übereinander aufzumachen und den backgrop richtig zu erhalten
        var zindex = 1040 + (10 * $('.modal:visible').length);
        $(this).css('z-index', zindex);
        setTimeout(function() {
            $('.modal-backdrop').not('.modal-stack').css('z-index', zindex - 1).addClass('modal-stack');
        }, 0);
    });

    var last_hash_val = window.location.hash;
    $(window).on('hashchange', function (event) {
        if(last_hash_val == "#share" && window.location.hash == "#detail"){
            $('#modal-share-product').modal('hide');
        }else {
            if(window.location.hash != "#modal" && window.location.hash != "#detail" && window.location.hash != "#share" && window.location.hash != "#swal") {
                $(".modal").modal('hide');
            }
        }
        last_hash_val = window.location.hash
    });

    $(window).on("popstate", function(e) {
        var state = e.originalEvent.state;
        var hash_val_location = location.hash.replace('#', '');

        if(hash_val_location != 'modal' && hash_val_location != 'detail' && hash_val_location != 'share' && hash_val_location != 'swal' ){
            //handleJsHashNavigation(hash_val_location, true);
            $(".modal").modal('hide');
        }else{
            //location.href = '/#watchlist';
        }
    });
    
    $('body').on('hide.bs.modal', '.modal', function (e) {
        if(last_hash_val == "#share" && window.location.hash == "#detail"){
            $('#modal-detail-page').trigger('focus');  // damit die Escape Taste auch funktioniert, muss der Focus dann auf dem Modal sein!
        }else{
            if(window.location.hash == "#modal" || window.location.hash == "#detail" || window.location.hash == "#share") {
                window.history.back();
            }
        }
    });

    $('body').on('hidden.bs.modal', '.modal', function (e) {
        $(this).removeData('bs.modal');
    });

    $('.collapse').on('shown.bs.collapse', function (e) {
        var $clickedBtn = $(e.target).data('bs.collapse').$trigger;

        if ($clickedBtn.hasClass('js-hide-on-collapse-shown')){
            $clickedBtn.hide();
        }

        if ($clickedBtn.hasClass('js-collapse-read-more')){
            $clickedBtn.closest('.read-more-container').addClass('more-opened');
        }
    });

    $('.collapse').on('hidden.bs.collapse', function (e) {
        var $clickedBtn = $(e.target).data('bs.collapse').$trigger;

        if ($clickedBtn.hasClass('js-collapse-read-more')){
            $clickedBtn.closest('.read-more-container').removeClass('more-opened');
        }
    });

    $('.js-collapse-read-more2').on('click', function (e) {
        var $parent_con = $(this).closest('.read-more-container-v2');
        var default_height = 60;  // same height set in CSS

        if($(this).attr('aria-full-expanded') == 'false'){
            $parent_con.css('height', 'auto').attr('aria-full-expanded', true);
            $(this).attr('aria-full-expanded', true);
            history.replaceState(null, '', window.location.pathname + '#readmore');
        }else{
            $parent_con.css('height', default_height + 'px').attr('aria-full-expanded', false);
            $(this).attr('aria-full-expanded', false);
            scrollToPosition('#geschenkideen-container', 0);
            history.replaceState(null, '', window.location.pathname);
        }
    });

    /* Set same height for each element with attribute data-sameheight */
    function setSameheight(ele) {
        var breakpoint = jRes.getBreakpoint();
        var heighest = 0;

        //if (breakpoint === 'smartphone') {
            //$(ele).removeAttr('style');
        //}else{
            if($(ele).hasClass('js-sameheight-in-row')){  // if class set, sameheight will calculated for items in each row!
                if($(ele).closest('.row').length && $(ele).closest('.row').find('[class*=col-]:visible').length > 1){
                    var elements_in_a_row = 1;
                    var $elem_visible_found = $(ele+':visible').first();
                    var count_elem_cols = $elem_visible_found.closest('.row').find(ele+':visible').length;
                    var container_width =  $elem_visible_found.closest('.row')[0].scrollWidth;
                    var elem_col_width = $elem_visible_found[0].getBoundingClientRect().width;
                    var last_elem_index_loop = 0;
                    elements_in_a_row = Math.floor(container_width / elem_col_width);
                    
                    if(elements_in_a_row == 1){
                        $(ele).css("height", "auto");
                    }else{
                        $(ele+':visible').each(function (i) {
                            i++;
                            var $element = $(this);
            
                            $element.css("height", "auto");
                            if ($element.height() > heighest) {
                                heighest = $element.height();
                            }

                            if(i == count_elem_cols){
                                // fix for last element, if element not last element in a row
                                $(ele+':visible').slice(last_elem_index_loop, i).height(heighest);
                                return false;
                            }

                            if(i % elements_in_a_row == 0){
                                $(ele+':visible').slice(i-elements_in_a_row, i).height(heighest);
                                heighest = 0;
                                last_elem_index_loop = i;
                            }
                            
                        });
                    }
                }
            }else{
                $(ele+':visible').each(function () {
                    var $element = $(this);
        
                    $element.css("height", "auto");
                    if ($element.height() > heighest) {
                        heighest = $element.height();
                    }
                });
                $(ele+':visible').height(heighest);
            }
        //}
    }

    function resizeSameheight() {
        var sameheight = $("[data-sameheight]"),
            sameheightclass = [],
            i;

        for (i = 0; i < sameheight.length; i = i + 1) {
            sameheightclass.push($(sameheight[i]).attr("data-sameheight"));
        }
        sameheightclass = $.uniqueSort(sameheightclass);
        for (i = 0; i < sameheightclass.length; i = i + 1) {
            setSameheight(sameheightclass[i]);
        }
    }

    if ($("[data-sameheight]").length) { 
        (function () {
            var resizetimer;

            $(window).on("resize", function () {
                clearTimeout(resizetimer);
                resizetimer = setTimeout(resizeSameheight, 250);
            });

            //setTimeout(function() {
                resizeSameheight();
            //}, 250);
        }());
    }

    /* Detect mobile device and show App Download bar if there is one */
    function checkApphint() {
        var elem_app_hint = $('.js-app-hint');
        
        function changeTopMargin() {
            $('body').css('margin-top', elem_app_hint.outerHeight());
        }

        if (elem_app_hint.length && checkCookie('cookieRead', 'true')) {
            if (userAgent !== undefined && userAgent !== 'ios' && elem_app_hint.find('a[data-device="' + userAgent + '"]').length && checkCookie('androidAppBannerShown', elem_app_hint.attr('data-app')) === null) {
                elem_app_hint.show();
                elem_app_hint.find('a[data-device="' + userAgent + '"]').removeClass('display-none');
                $('body').css('margin-top', elem_app_hint.outerHeight());
                $(window).on('resize', changeTopMargin);

                $('a.js-app-load, a.js-app-close').click(function (e) {
                    var element = $(this),
                        ctime = 1;

                    if (element.hasClass('js-app-load')) {
                        ctime = 365;
                    }
                    setCookie('androidAppBannerShown', elem_app_hint.attr('data-app'), ctime);
                    element.closest('.js-app-hint').slideUp();
                    $('body').css('margin-top', 0);
                    $(window).off('resize', changeTopMargin);
                    if (element.hasClass('js-app-close')) {
                        e.preventDefault();
                    }
                });
            }
        }
    }
    checkApphint();


    /* Cookie hint Datenschutz */
    function checkCookieRead(cookie_name) {
        var ckele = $('.js-cookie-hint');

        function changeTopMargin() {
            $('body').css('margin-top', ckele.outerHeight());
        }

        ckele.show();
        $('body').css('margin-top', ckele.outerHeight());
        $(window).on('resize', changeTopMargin);

        $('a.js-cookie-accept').click(function(e) {
            setCookie(cookie_name, 'true', 1825);  // 5 years
            $(this).closest('.js-cookie-hint').slideUp();
            $('body').css('margin-top', 0);
            checkApphint();
            $(window).off('resize', changeTopMargin);
            e.preventDefault();
        });
    }

    if (checkCookie('cookieRead', 'true') === null) {
        checkCookieRead('cookieRead');
    }

    /* zur Zeit nicht benötigt
    $("#slider-alter").on('input', function(){
        $("#filter-alter").val($(this).val());
    });
    $("#slider-preis-von").on('input', function(){
        $("#filter-preis-von").val($(this).val());
    });
    $("#slider-preis-bis").on('input', function(){
        $("#filter-preis-bis").val($(this).val());
    });
    */

    $('body').on('change', '#filter-alter, #slider-alter, #filter-preis-von, #filter-preis-bis,#slider-preis-bis, #filter-anlass, #filter-empfaenger, #filter-sortierung', function(e) {
        geschenkideen_suche();
    });    
  
    $('body').on('input', '#URL', function(e) {
        var value = $(this).val();
        $('#form-edit-add-gift-idea').trigger("reset");
        $('.js-image-preview, .js-image-preview-large').attr('src', '');
        $('.js-link-url').attr('href', value);
        $('#URL').val(value);

        $.ajax({
            type:'POST',
            url:'/intern/parseURL',
            data : {'url' : $('#URL').val()},
            success:function(data){
                if(data.title != ''){
                    $('#Bezeichnung').val(data.title);
                }
                if(data.price_german_format != ''){
                    $('#Preis').val(data.price_german_format);
                }
                if(data.price_savingbasis != ''){
                    $('#PreisUVP').val(data.price_savingbasis);
                }
                if(data.features != ''){
                    $('#Amazontext').val(data.features);
                }
                if(data.classification != ''){
                    $('#Klassifikation').val(data.classification);
                }
                if(data.image_url != ''){
                    $('#Bild').val(data.image_url);
                    $('.js-image-preview').attr('src', data.image_url);
                }
                if(data.image_url_large != ''){
                    $('#BildLarge').val(data.image_url_large);
                    $('.js-image-preview-large').attr('src', data.image_url_large);
                }
                if(data.ASIN != ''){
                    $('#UniqueID').val(data.ASIN);
                }
                $('#URLaffiliated').val(data.url_affiliated);
                $('.js-link-url-affiliated').attr('href', data.url_affiliated);

            },
            error:function(data){
                //console.log(data)
            }
        });
    });

    $('body').on('click', 'a.external-link', function(e) {
        $.ajax({
            type: "POST",
            url: "/allgemein/shopklick",
            data: { ID : $(this).attr('data-id') }
        });
    });

    $('body').on('click', 'a.conversion', function(e) {
        gtag('event', 'conversion', {'send_to': 'AW-371123824/YI3rCKy5wf8CEPDM-7AB'});
    });

    $('form[name="suchformular"]').on("submit", function(e) {
        location.href = "/suche/geschenkidee/"+$(this).find("[name='geschenkidee']").val();
        e.preventDefault();
    });

    $('input[name=Anzeigename]').keyup(function() {
        var value = seourl(this.value);
        $('input[name=URLname]').val(value);
    });

    $('input[name=Anzeigename]').on('change', function() {
        var value = $('input[name=URLname]').val();

        $.ajax({
            type:'POST',
            url:'/intern/checkUniqueUrlName',
            data : {'urlname' : value},
            success:function(data){
                if(data.error == 1){
                    $('#URLname').addClass('form-error');
                }else{
                    $('#URLname').removeClass('form-error');
                }
            },
            error:function(data){
                $('#URLname').addClass('form-error');
            }
        });
    });

    $('body').on('click', '.js-check-all-checkboxes, .js-uncheck-all-checkboxes', function(e) {
        var element_name = $(this).data('checkbox-name');
        if($(this).hasClass('js-check-all-checkboxes')){
            $('input:checkbox[name="'+element_name+'"]').prop('checked', true);
        }else{
            $('input:checkbox[name="'+element_name+'"]').prop('checked', false);
        }
    });

    // open and close navbar dropdown on mouseover
    (function(){
        var breakpoint = jRes.getBreakpoint();

        if(breakpoint == 'desktop'){
            $(".navbar .dropdown").on({
                mouseenter: function () {
                    $(this).addClass('open');
                },
                mouseleave: function () {
                    $(this).removeClass('open');
                }
            });
        }
    })();

    $('body').on('click', '.js-toggle-checkbox', function(e) {
        if($(this).hasClass('active')){
            $(this).removeClass('active');
        }else{
            $(this).addClass('active');
        }

        if($(this).closest('#js-filter-gifts').length){
            geschenkideen_suche();
        }
    });

    function geschenkideen_suche(){
        var preis_von = $('#filter-preis-von').val();
        var preis_bis = $('#filter-preis-bis').val();
        var anlass = $('#filter-anlass').val();
        var alter = $('#filter-alter').val();
        var geschlecht = '';
        $('.js-filter-gender').each(function() {
            if($(this).hasClass('active')){
                geschlecht += $(this).attr('data-value');
            }
        });
        var empfaenger = $('#filter-empfaenger').val();
        var sortierung = $('#filter-sortierung').text();
        var kategorie = '';
    
        var tmp = [];
        $('.js-filter-category').each(function() {
            if($(this).hasClass('active')){
                tmp.push($(this).attr('data-value'));
            }
        });

        var istopgeschenk = '0';
        if($('.js-filter-istopgeschenk').hasClass('active'))
            istopgeschenk = 1;
    
        kategorie = tmp.join(',');
    
        $.ajax({
            type:'POST',
            url:'/allgemein/startseite',
            data : {'ajax' : 1, 
                    'filter-geschlecht' : geschlecht, 
                    'filter-preis-von' : preis_von, 
                    'filter-preis-bis' : preis_bis, 
                    'filter-anlass' : anlass,
                    'filter-alter' : alter,
                    'filter-empfaenger' : empfaenger,
                    'filter-sortierung' : sortierung,
                    'filter-kategorie' : kategorie, 
                    'filter-istopgeschenk' : istopgeschenk},
            success:function(data){
                var $loaded_content_count_filters = $(data).find('.js-count-filters');
                var $loaded_content = $(data).find('.gift-ideas-wrapper');
                var $loaded_content_gift_results = $(data).find('.js-count-gift-results');

                $('.js-count-filters').replaceWith($loaded_content_count_filters);
                $('.gift-ideas-wrapper').replaceWith($loaded_content);
                $('.js-update-gift-results').replaceWith($loaded_content_gift_results);
                lazyLoadInstance.update();
                resizeSameheight();  // damit werden die Boxen neu berechnet!
            },
            fail:function(data){
                
            }
        });
    }
    
    $('body').on('click', '.js-open-mobile-search', function(e) {
        $('.js-navbar-header-search').show();
        $('.js-navbar-header-main').hide();
        $('.js-navbar-header-search .js-search-input').focus();
        //history.pushState(null, 'suche', '/#search');
    });
    
    $('body').on('click', '.js-go-back-btn', function(e) {
		e.preventDefault();
		history.go(-1);
	});

    $('.js-button-close-search').on('click', function(e){
        e.preventDefault();
        $('.js-navbar-header-main').show();
        $('.js-navbar-header-search').hide();
    });


    $('body').on('click', '.js-save-favorite', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $this = $(this);
        var target_url = $(this).attr('data-url');        
        var giftid = $(this).attr('data-gift-id');        
        var action = $(this).attr('data-action');
        var remove_item_html = $(this).hasClass('js-is-favorite') ? true : false;
        var $remove_elem_favorits = $(this).closest('.wish-wrapper');
        
        $.ajax({
            type: "POST",
            url: target_url,
            data: { id : giftid, action : action },
            success: function(response){
                var unpackArr = JSON.parse(response);
                var status = unpackArr.status;
                var message = unpackArr.message;
                var wish_counter = parseFloat($('.js-nav-heart-counter').attr('data-wish-counter'));

                $('.js-nav-heart').removeClass('animated tada');
                $('.js-nav-heart-counter').removeClass('animated fadeInUpBig')

                if(action == 'add'){
                    wish_counter++;
                    if(status == 'success'){
                        ToastSwal.fire({
                            icon: 'success',
                            title: message
                        });
                    }
                    $('.js-save-favorite[data-gift-id='+giftid+']').attr('data-action', 'delete');
                    $this.addClass('animated tada');
                    $('.js-nav-heart').addClass('animated tada');
                }else{
                    wish_counter--;
                    if(status == 'success'){
                        if(remove_item_html){  // on favorites page, remove wish item from dom
                            $remove_elem_favorits.addClass('js-remove-animated js-check-same-height animated bounceOutUp');
                        }else{
                            ToastSwal.fire({
                                icon: 'success',
                                title: message
                            });
                        }
                    }
                    if(!remove_item_html){
                        $('.js-save-favorite[data-gift-id='+giftid+']').attr('data-action', 'add');
                    }
                }
                if(wish_counter < 0){
                    wish_counter = 0;
                }
                $('.js-nav-heart-counter').attr('data-wish-counter', wish_counter).addClass('animated fadeInUpBig');
            },
            fail:function(data){
                //new PNotify({title: 'Fehler', text: 'Beim Speichern trat ein Fehler auf.'});
                //showNotify('Fehler', 'Beim Speichern trat ein Fehler auf.', 'error');
            }
        });
    });

    $('body').on('animationend webkitAnimationEnd oanimationend MSAnimationEnd', '.animated.js-remove-animated', function(e) {
        $(this).remove();
        if($(this).hasClass('js-check-same-height')){
            resizeSameheight();
        }
        checkDeleteFavoritesInfo();
    });

    $('body').on('animationend webkitAnimationEnd oanimationend MSAnimationEnd', '.animated', function(e) {
        $(this).removeClass('animated');
    });

    $('#modal-detail-page').on('animationend webkitAnimationEnd oanimationend MSAnimationEnd', '.animated-slow.js-swipe', function(e) {
        setCookie('modalSwipeableDemoSeen', 'true', 60);  // 60 Tage
        $(this).closest('.swipeable-demo').fadeOut();
    });

    function checkDeleteFavoritesInfo(){
        if($('#favorites .wish-wrapper').length){
            $('.js-delete-favorites-info').removeClass('display-none');
        }else{
            $('.js-delete-favorites-info').addClass('display-none');
        }
    }

    // entferne alle hashes beim Laden der Seite
    //window.location.hash = '';
    if(window.location.hash != ''){
        var urlhash = location.hash.replace('#', '');
        var scroll_top_pos = 0;
        
        history.replaceState('', '', window.location.pathname);  // das muss vor dem Trigger readmore immer passieren, damit die Akkordeons funktionieren.

        if(urlhash == 'readmore'){
            scroll_top_pos = document.documentElement.scrollTop;
            $('.js-collapse-read-more2').trigger('click');

            if(scroll_top_pos > 0){
                $('html, body').stop().animate({
                    scrollTop: scroll_top_pos
                }, 50);
            }
        }
    }

    $('.dropdown-menu.dropdown-menu-like-select a').on('click', function(e){
        e.preventDefault();
        $(this).closest('.btn-group').find('.dropdown-button-text').html($(this).attr('data-value'));    
    });

    $('.js-filter-sortierung').on('click', function(e){
        e.preventDefault();
        geschenkideen_suche();
    });

    /* Ripple Test Caner */
    $('body').on('click', '.js-ripple', function(e) {
        var $this = $(this);
        var $offset = $this.parent().offset();
        var $circle = $this.find('.c-ripple__circle');

        var x = e.pageX - $offset.left;
        var y = e.pageY - $offset.top;

        $circle.css({
            top: y + 'px',
            left: x + 'px'
        });

        $this.addClass('is-active');
    });

    $('body').on('animationend webkitAnimationEnd oanimationend MSAnimationEnd', '.js-ripple', function(e) {
        $(this).removeClass('is-active');
    });


    // Teilen Funktion
    $('body').on('click', '.js-share-product', function(e) {
        var target = $(this).attr('data-target-custom');
        var share_url = $(this).data('share-url') !== undefined ?  $(this).data('share-url') : $('.js-product-info').attr('data-href');
        var share_title = $(this).data('share-title') !== undefined ?  $(this).data('share-title') : $('.js-product-info').attr('data-title');

        if (navigator.share) {
            e.preventDefault();
            navigator.share({
                title: 'Share Product',
                text: share_title,
                url: share_url,
            })
            .then(function() {
                //console.log('Successful share')
            })
            .catch(function(error) {
                //console.log('Error sharing', error);
            });
        }else{
            $('body').on('show.bs.modal', '#modal-share-product', function(e) {
                var $modal = $(this);
                var $trigger = $(e.relatedTarget);
                
                $modal.find('.modal-title').text(share_title);
                $modal.find('.js-change-url').each(function(){
                    var tmp_href = $(this).attr('data-href') + share_url;
                    $(this).attr('href', tmp_href);
                });
            });

            $(target).modal('show');  // muss nach dem show.bs.modal kommen
        }
    });  
    
    
    $('body').on('inview', '.gift-ideas-wrapper .js-infinite-last-elem', function (event, isVisible) {
        $('.gift-ideas-wrapper .js-infinite-last-elem').removeClass('js-infinite-last-elem');
        $('.gift-ideas-wrapper .wish-wrapper.display-none').eq(15).addClass('js-infinite-last-elem');
        $('.gift-ideas-wrapper .wish-wrapper.display-none').slice(0,20).removeClass('display-none');
        resizeSameheight();
    });

    $('body').on('click', '.js-paginate-detail-page:not(.disabled)', function(e) {
        var detail_url = '';
        var wish_pos = $('#modal-detail-page').find('.modal-body').attr('data-wish-index');
        var fade_out_class_name = '';
        var fade_in_class_name = '';

        if($(this).is('[data-paginate=previous]')){
            wish_pos--;
            fade_out_class_name = 'fadeOutRightBig';
            fade_in_class_name = 'fadeInLeftBig';
        }else{
            wish_pos++;
            fade_out_class_name = 'fadeOutLeftBig';
            fade_in_class_name = 'fadeInRightBig';
        }

        if($('#modal-detail-page').find('.modal-body').attr('data-target-parent-id') == 'gift-ideas-results-wrapper'){
            detail_url = $('#gift-ideas-results .wish-wrapper').eq(wish_pos).find('a.wish').attr('href');
        }else{
            detail_url = $('#page-text-wrapper a.inline-linked-wish').eq(wish_pos).attr('href');
        }

        $('#modal-detail-page .modal-body').removeClass('fadeOutLeft fadeOutRightBig fadeInRightBig fadeInLeftBig');
        $('#modal-detail-page .modal-body').addClass('animated-half-speed ' + fade_out_class_name);
        loadDetailToModal($('#modal-detail-page'), wish_pos, detail_url, fade_in_class_name);
    });

    $('body').on('click', '.gift-ideas-wrapper a.wish', function(e) {
        if($('#modal-detail-page').hasClass('in')){
            var detail_url =  $(this).attr("href");
            e.preventDefault();
            e.stopPropagation();

            loadDetailToModal($('#modal-detail-page'), false, detail_url);
        }
    });
    
    // open detail page in modal
    $('body').on('show.bs.modal', '#modal-detail-page', function(e) {
        var $this_modal = $(this);
        var $target = $(e.relatedTarget);
        var wish_id = $target.attr('data-wish-id');
        var wish_pos = $target.closest('.wish-wrapper').index();
        var detail_url = $target.attr("href");
        
        if($target.hasClass('inline-linked-wish')){
            $this_modal.find(".modal-body").attr('data-target-parent-id', 'page-text-wrapper');  // Aus Fließtext oder Liste geöffnet
        }else{
            $this_modal.find(".modal-body").attr('data-target-parent-id', 'gift-ideas-results-wrapper');  // Aus normalen Geschenkideen geöffnet
        }

        if(wish_pos < 0){
            if($target.parents('#page-text-wrapper').length){
                wish_pos = $target.closest('#page-text-wrapper').find('a.inline-linked-wish').index($target);
            }
        }

        loadDetailToModal($this_modal, wish_pos, detail_url, null);

        $this_modal.find('.modal-body').off("scroll").on('scroll', function(){  // muss zuerst auf off gesetllt werden!
            $this_modal.find('.js-goto-shop-btn-main').off('inview').on('inview', function (event, isVisible) {
                if(!isVisible){
                    $('.js-goto-shop-btn-secondary').removeClass('invisible').addClass('animated bounceIn');
                }else{
                    // machen wir daweil mal nicht
                    //$('.js-goto-shop-btn-secondary').removeClass('animated bounceIn').addClass('invisible');
                }                
            });
        });
    });


    function loadDetailToModal($this_modal, wish_pos, detail_url, fade_in_class_name){
        var shop_url;
        $this_modal.find('.modal-content').addClass('is-loading');
        $this_modal.find(".modal-footer .js-paginate-detail-page").removeClass('disabled');
        $this_modal.find('.modal-footer .js-goto-shop-btn-secondary').removeClass('animated bounceIn').addClass('invisible');  // Shop Button zurücksetzen
        $this_modal.find(".modal-footer").html($this_modal.find(".modal-footer").html());  // fix um den aktiven Button Status zu overriden.
        
        $this_modal.find(".modal-body").load(detail_url, function(){
            $this_modal.find('.modal-body').animate({ scrollTop: 0 }, 'fast');
            $this_modal.find('.modal-content').removeClass('is-loading');

            $('#modal-detail-page .modal-body').removeClass('fadeOutLeftBig fadeOutRightBig fadeInRightBig fadeInLeftBig');
            if(fade_in_class_name !== undefined){
                $('#modal-detail-page .modal-body').addClass('animated-half-speed ' + fade_in_class_name);
            }

            // URL auf kleinen Shop Button setzen
            if($this_modal.find('.modal-body .js-goto-shop-btn-main').length){
                shop_url = $this_modal.find(".modal-body .js-goto-shop-btn-main").attr('href');
                $this_modal.find('.modal-footer .js-goto-shop-btn-secondary').attr('href', shop_url);
            }else{
                $this_modal.find('.modal-footer .js-goto-shop-btn-secondary').removeAttr('href');
            }

            resizeSameheight();
            lazyLoadInstance.update();
            history.replaceState(null, detail_url, detail_url + '#detail');
        });

        if(wish_pos !== false){
            $this_modal.find(".modal-body").attr('data-wish-index', wish_pos);

            if(wish_pos < 1){
                $this_modal.find(".modal-footer .js-paginate-detail-page[data-paginate=previous]").addClass('disabled');
            }

            if($this_modal.find('.modal-body').attr('data-target-parent-id') == 'gift-ideas-results-wrapper'){
                if (wish_pos == $('#gift-ideas-results .wish-wrapper').length - 1){  // letzte Geschenkidee
                    $this_modal.find(".modal-footer .js-paginate-detail-page[data-paginate=next]").addClass('disabled');
                }
            }else{
                if (wish_pos == $('#page-text-wrapper a.inline-linked-wish').length - 1){  // letztes verlinktes Geschenk
                    $this_modal.find(".modal-footer .js-paginate-detail-page[data-paginate=next]").addClass('disabled');
                }
            }
        }
    }

    $("#modal-detail-page").on("hidden.bs.modal", function(){
        $(this).find(".modal-body").html("");
    });


    /* hammer js */
    if(deviceSupportsTouch){
    //if (isMobile.any()) {
        var myElement = $('#modal-detail-page .modal-content:not(.is-loading) .modal-body')[0];
        
        // create a simple instance
        // by default, it only adds horizontal recognizers
        var mc = new Hammer(myElement);
        //mc.get('pan').set({ direction: Hammer.DIRECTION_ALL });

        $('.swipeable-demo').removeClass('display-none');

        // listen to events...
        mc.on("swipeleft swiperight", function(ev) {
            var event_type = ev.type; 
            
            if ($(ev.target).parents('.mobile-scroll-x').length) {
                // der Bereich zum Scrollen soll nicht swipebar sein    
            }else{
                if(event_type == 'swiperight'){
                    $('.js-paginate-detail-page[data-paginate=previous]').trigger('click');
                }else if(event_type == 'swipeleft'){
                    $('.js-paginate-detail-page[data-paginate=next]').trigger('click');
                }
            }
        });
    //}
    }

    // scroll to top function
    if ($('#pageup').length) {
        (function(){
            var pageup = $('#pageup');
            var lastScrollTop = 0;
            var delta = 50;  // px to scroll before show header

            $('body').on('click', '#pageup', function(e) {
                e.preventDefault();
                var elements = 'html, body';

                // if modal open, scroll top modal
                if ($('.modal').is(':visible')) {
                    elements = '.modal';
                }

                $(elements).stop().animate({
                    scrollTop: 0
                }, 50, function(){
                    $('#pageup').blur();
                    $('#pageup').unbind('mouseenter mouseleave');
                });
            });

            function calculateIfShowPageup(fromTop){
                var header_height = $('.navbar').outerHeight();

                if(fromTop < 400){
                    pageup.removeClass('active');
                    $('.navbar').removeClass('fadeInDown fadeOutUp');
                    setTimeout(function() {
                        $('.navbar').removeClass('navbar-fixed-top animated-half-speed fadeOutUp');
                        $('.content-wrapper').removeAttr('style');
                    }, 10);
                }else{
                    if (fromTop > lastScrollTop){
                        // downscroll code
                        pageup.removeClass('active');
                        $('.navbar').removeClass('fadeInDown').addClass('fadeOutUp');
                        setTimeout(function() {
                            $('.navbar').removeClass('navbar-fixed-top');
                            $('.content-wrapper').removeAttr('style');
                        }, 10);
                    } else {
                        if(Math.abs(lastScrollTop - fromTop) <= delta){
                            return;
                        }

                        $('.navbar').removeClass('fadeOutUp').addClass('navbar-fixed-top animated-half-speed fadeInDown');
                        if(!$('#app-hint:visible').length && !$('#cookie-hint:visible').length){  // fix for header margin, if cookie or app banner is shown
                            $('.content-wrapper').css('margin-top', header_height);
                        }
                        // upscroll code
                        pageup.addClass('active');
                    }
                }

                lastScrollTop = fromTop;
            }

            $(window).scroll(function(event){
                var fromTop = $(window).scrollTop();
                // nice2have: damit beim Klick auf die Akkordeons nicht kurzzeitig das Hauptmenü reinflackert, da in manchen Fällen ein Stückchen raufgescrollt wird!
                if( $(document.activeElement).next('div.accordion-txt').is(':animated') ){
                    return;
                }
                calculateIfShowPageup(fromTop);
            });
        })();
    }

    /* Inititate Accordions */
    (function() {
        var i,
            elements = $('a.accordion-headline'),
            elementslength = elements.length;

        // Close all Accordions which haven't class 'active'
        for (i = 0; i < elementslength; i = i + 1) {
            if ($(elements[i]).hasClass('active') === false) {
                $(elements[i]).find('.accordion-arrow').removeClass('fa-angle-up').addClass('fa-angle-down').end()
                    .next('div.accordion-txt').hide().removeClass('active');
            }
        }
        // Add click event to all Accordions
        $(document).on("click", "a.accordion-headline", function(e) {
            var element = $(this);
            var parent = element.closest('.accordion-container');

            if (element.hasClass('active')) {
                element.removeClass('active').find('.accordion-arrow').removeClass('fa-angle-up').addClass('fa-angle-down').end()
                    .next('div.accordion-txt').slideUp(50).removeClass('active');
            } else {
                // in single accordion only one accordion can be open at once
                if(parent.hasClass('is-single-accordion')){
                    parent.find('div.accordion-txt').slideUp(50).removeClass('active');
                    parent.find('.accordion-headline').removeClass('active');
                }

                element.addClass('active').find('.accordion-arrow').removeClass('fa-angle-down').addClass('fa-angle-up').end()
                    .next('div.accordion-txt').slideDown(50).addClass('active');
            }
            
            e.preventDefault();
        });
    }());

    /* Trigger ScrollTo if url hash value matches element or if anchor href id page anchor */
    (function() {
        var urlhash = location.hash.replace('#', ''),
            hashele,
            scrollele = '#' + urlhash,
            breakpoint = jRes.getBreakpoint();

        // Check if url hash matches with an Accordion and set class 'active' and scroll to it, remove class 'active' from all other Accordions
        if (urlhash !== '') {
            if ($('#' + urlhash).length) {
                hashele = $('#' + urlhash);
            } else if ($('[name="' + urlhash + '"]').length) {
                hashele = $('[name="' + urlhash + '"]');
                scrollele = '[name="' + urlhash + '"]';
            }
            if (hashele !== undefined) {
                if (hashele.hasClass('accordion-headline') && hashele.hasClass('active') === false) {
                    //$('a.accordion-headline').removeClass('active');
                    hashele.addClass('active').find('.accordion-arrow').removeClass('fa-angle-down').addClass('fa-angle-up').end()
                        .next('.accordion-txt').show();
                }
                if (hashele.hasClass('tab-pane')) {
                    if (breakpoint === 'smartphone') {
                        if ($('a.accordion-headline[href="#' + urlhash + '"]').hasClass('active') === false) {
                            $('a.accordion-headline[href="#' + urlhash + '"]').click();
                        }
                    }
                    scrollele = $('a[href="#' + urlhash + '"]');
                }
                setTimeout(function() {
                    scrollToPosition(scrollele);
                }, 500);
            }
        }
    }());

    $('body').on('click', 'a[href^="#"]', function(e) {
        var element = $(this),
            elementhash = element.attr('href').replace('#', ''),
            hashelement,
            scrollelement = '#' + elementhash,
            breakpoint = jRes.getBreakpoint();

        if (element.attr('role') !== 'tab' && element.hasClass('accordion-headline') === false && elementhash.length > 1) {
            if ($('#' + elementhash).length) {
                hashelement = $('#' + elementhash);
            } else if ($('[name="' + elementhash + '"]').length) {
                hashelement = $('[name="' + elementhash + '"]');
                scrollelement = '[name="' + elementhash + '"]';
            }
            if (hashelement !== undefined) {
                e.preventDefault();
                if (hashelement.hasClass('accordion-headline') && hashelement.hasClass('active') === false) {
                    //$('a.accordion-headline').removeClass('active');
                    hashelement.addClass('active').find('.accordion-arrow').removeClass('fa-angle-down').addClass('fa-angle-up').end()
                        .next('.accordion-txt').show().addClass('active');
                }
                if (hashelement.hasClass('tab-pane')) {
                    if (breakpoint === 'smartphone') {
                        if ($('a.accordion-headline[href="#' + elementhash + '"]').hasClass('active') === false) {
                            $('a.accordion-headline[href="#' + elementhash + '"]').click();
                        }
                    } else {
                        scrollelement = '#js-' + elementhash;
                        $(scrollelement).click();
                    }
                }
                setTimeout(function () {
                    scrollToPosition(scrollelement);
                    element.blur();
                }, 500);
                
            }
        }
    });


    $('.js-check-captcha').submit(function(e) {
        e.preventDefault();
        var $this = $(this);
        var recaptcha_website_key = $('#g-recaptcha-response').data('website-key');

        //if($(this).closest(form).valid()){
            grecaptcha.ready(function() {
                grecaptcha.execute(recaptcha_website_key, {action: 'homepage'})
                    .then(function(token) {
                        $('#g-recaptcha-response').val(token);
                        setTimeout(function(){
                            var postData = new FormData($("#form")[0]);
                            
                            $.ajax({
                                type:'POST',
                                url:'/kontakt',
                                processData: false,
                                contentType: false,
                                data : postData,
                                success:function(data){
                                    if(data.status == 'success'){
                                        CustomHashSwal.fire({
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            title: data.title,
                                            html: data.message,
                                            icon: 'success',
                                            confirmButtonText: 'Ok'
                                        }).then(function (result) {
                                            $this[0].reset();
                                            history.go(-1);
                                        });
                                        //$('.js-form-contact').hide();
                                        //$('.contact-mail-sent-succes').fadeIn();
                                    }else{
                                        CustomHashSwal.fire({
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            title: data.title,
                                            html: data.message,
                                            icon: 'error',
                                            confirmButtonText: 'Ok'
                                        });
                                        //$('.contact-mail-send-error').fadeIn();
                                    }
                                },
                                error: function(data){
                                    $('.contact-mail-send-error').fadeIn();
                                },
                                complete: function(){
                                    $this.find('.btn-loading').button('reset');
                                }
                            });
                        }, 200);
                });
            });
        //}
    });
});


